import type { CommonResourceKey } from './common';
import { commonResources } from './common';
import type { LayoutResourceKey } from './layout';
import { layoutResources } from './layout';
import type { AccountResourceKey } from './account';
import { accountResources } from './account';

export const FRResources: Record<FRResourceKey, string> = {
  ...commonResources,
  ...layoutResources,
  ...accountResources,
};

type FRResourceKey = CommonResourceKey | LayoutResourceKey | AccountResourceKey;
